import { render, staticRenderFns } from "./CompanySiteReviewTasks.vue?vue&type=template&id=2b02a94b"
import script from "./CompanySiteReviewTasks.vue?vue&type=script&lang=js"
export * from "./CompanySiteReviewTasks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports